import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import { API_ERROR_500 } from "../../../../config";
import { setLoading } from "../../../../redux/common/commonAction";
import { getDgLocker } from "../PanAddress/redux/action";
import {
  getStageScreen,
  setAddressForcefullyRedux,
} from "../../../../redux/navigation/navigationAction";
import Title from "../../components/Title";
import TextInput from "../../components/TextInput";
import TextArea from "../../components/TextArea";
import Button from "../../components/Button";
import Label from "../../components/Label";
import "./style.css";
import { Modal } from "react-bootstrap";
import {
  saveIsPermanentChange,
  getIsPermanentChange,
  removeIsPermanentChange,
} from "./Helpers";
import {
  jsonToFormData,
  getApiUrl,
  VACHANA_API_URL,
  showPrevBtnByUrl,
  showNextBtnByUrl,
  getPrevAndNextRoute,
} from "utils";
import AccountQA from "./Components/AccountQA";

const addressTypes = [
  { name: "None", value: "" },
  { name: "Aadhaar", value: "Aadhaar" },
  { name: "Voter ID", value: "VoterID" },
  { name: "Passport", value: "Passport" },
  { name: "Driving License", value: "DrivingLicense" },
  { name: "Other", value: "Other" },
];

const PersonalData = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { inputLabelColor, inputError, exchangeSegment } = useSelector(
    (state) => state.theme
  );
  const { digilocker, pageFlow, kycStatus, kycPageName } = useSelector(
    (state) => state.navigation
  );
  const [inputForQuestions, setInputForQuestions] = useState(false);
  const [motherName, setMotherName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [spouseName, setSpouseName] = useState({
    spouse_first_name: "",
    spouse_last_name: "",
  });
  const [gender, setGender] = useState("Male");
  const [maritalStatus, setMaritalStatus] = useState("");
  const [isPermanentAddressChange, setIsPermanentAddressChange] =
    useState("No");
  const [permanentAddressSame, setPermanentAddressSame] = useState("Yes");
  const [isAddressChanged, setIsAddressChanged] = useState("");
  const [isPincodeChanged, setIsPincodeChanged] = useState("");
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [pincode, setPinCode] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [commAddressLine1, setCommAddressLine1] = useState("");
  const [commPincode, setCommPinCode] = useState("");
  const [commCity, setCommCity] = useState("");
  const [commState, setCommState] = useState("");
  const [commCountry, setCommCountry] = useState("");
  const [commProof, setCommProof] = useState({
    type: "",
    file1: "",
    file2: "",
    file_type: "Image",
    address_proof_name: "",
    isAddressChanged: true,
  });
  const [landmark, setLandmark] = useState("");
  const [stockExperienct, setStockExperience] = useState("");
  const [occupation, setOccupation] = useState("Private Sector");
  const [occupationName, setOccupationName] = useState("");
  const [annualIncome, setAnnualIncome] = useState("Upto 1 Lakh");
  const [sourceofincome, setSourceofincome] = useState("");
  const [nationality, setNationality] = useState("Indian");
  const [modeOfReceivingEcn, setModeOfReceivingEcn] = useState(
    "Electronic Contract Note"
  );
  const [frequencyOfAccountSettlement, setFrequencyOfAccountSettlement] =
    useState("Quarterly");
  const [tradingExchangeSegment, setTradingExchangeSegment] = useState({
    cash: [],
    fno: [],
    currency_derivatives: [],
    commodities: [],
    debt: [],
    slb: [],
  });
  const [isExchangeSegment, setIsExchangeSegment] = useState("No");
  const [pep, setPep] = useState(null);
  const [relatedToPep, setRelatedToPep] = useState(null);
  const [ecn, setEcn] = useState(null);
  const [bsdaConfirmation, setBsdaConfirmation] = useState(null);
  const [sebiAction3years, setSebiAction3years] = useState("No");
  const [fatca, setFatca] = useState(true);
  const [citizenOfOtherCountry, setCitizenOfOtherCountry] = useState();
  const [mappingUccDeclaration, setMappingUccDeclaration] = useState(false);
  const [allowedPEP, setAllowedPEP] = useState(false);
  const [allowedECN, setAllowedECN] = useState(false);
  const [wishtoreceiveaccountstatement, setWishtoreceiveaccountstatement] =
    useState("Daily");
  const [wishtoreceiveannualreport, setWishtoreceiveannualreport] =
    useState("Physically");
  const [liketoshareemailwithrta, setLiketoshareemailwithrta] = useState("Yes");
  const [easiallowsbo, setEasiallowsbo] = useState("No");
  const [nonissuanceofdeliveryslip, setNonissuanceofdeliveryslip] = useState(
    "I/We require you to issue Delivery Instruction Slip (DIS)"
  );
  const [submitted, setSubmitted] = useState(false);
  const [isPincodeAvail, setIsPincodeAvail] = useState(false);
  const [personalValues, setPersonalValues] = useState();
  const [personalFields, setPersonalFields] = useState([]);

  const [pinCodeApiCount, setPinCodeApiCount] = useState(0);
  const [debounceTimer, setDebounceTimer] = useState(null);

  const [depositryChargesQuestions, setDepositryChargesQuestions] = useState([
    { question: "1", answer: "Yes" },
    { question: "2", answer: "Yes" },
    { question: "3", answer: "As per SEBI Regulation" },
    { question: "4", answer: "Yes" },
    { question: "5", answer: "Yes" },
    { question: "6", answer: "Physical" },
    { question: "7", answer: "Yes" },
    { question: "8", answer: "Yes" },
    { question: "9", answer: "Yes" },
    { question: "10", answer: "Yes" },
    { question: "11", answer: "Yes" },
  ]);
  const [personalInfo, setPersonalInfo] = useState({});

  useEffect(() => {
    const getAccountFormApi = () => {
      let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
      API_URL_NEW = API_URL_NEW
        ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
        : "";
      const token = window.sessionStorage.getItem("token");
      const headers = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
          Authorization: `Basic ${token}`,
        },
      };
      axios
        .post(
          `${API_URL_NEW}//api/method/kyc_customizations.apis.kyc_page.api.get_account_opening_form`,
          {},
          headers
        )
        .then((result) => {
          const { data } = result.data;
          setInputForQuestions(
            data?.keep_fix_input_for_questions === "Yes" ? false : true
          );
        })
        .catch((error) => {});
    };
    getAccountFormApi();
  }, []);

  useEffect(() => {
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    axios
      .get(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.get_update_personal_data`,
        headers
      )
      .then((result) => {
        const { data } = result.data;
        if (data) {
          if (getApiUrl() === VACHANA_API_URL) {
            if (!data.depositry_charges_questions?.length) {
              debounceUpdatePersonalDataField(
                "depositry_charge_questions",
                depositryChargesQuestions
              );
            }
            setPersonalInfo(data);
            if (data.depositry_charges_questions?.length) {
              setDepositryChargesQuestions(
                data.depositry_charges_questions.map((item) => ({
                  question: item.question,
                  answer: item.answer,
                }))
              );
            }
          }
          setMotherName(data.mothers_name || "");
          setFatherName(data.fathers_name || "");
          setSpouseName({
            spouse_first_name: data.spouse_first_name || "",
            spouse_last_name: data.spouse_last_name || "",
          });
          setGender(data.gender || "Male");
          setMaritalStatus(data.marital_status);
          setIsPermanentAddressChange(
            data.permanent_address_changed || getIsPermanentChange() || "No"
          );
          setPermanentAddressSame(data.is_corr_and_perm_address_same || "Yes");
          setIsAddressChanged(
            data.address_line1?.toUpperCase() || addressLine1
          );
          setAddressLine1(data.address_line1?.toUpperCase() || addressLine1);
          setPinCode(data.pincode || pincode);
          setIsPincodeChanged(data.pincode || pincode);
          setStockExperience(data.experience_in_stock_market || "");
          setOccupation(data.occupation || "Private Sector");
          setAnnualIncome(data.annual_income || "Upto 1 Lakh");
          setSourceofincome(data.source_of_income || "");
          setNationality(data.nationality || "Indian");
          setModeOfReceivingEcn(
            data.mode_of_receiving_ecn || "Electronic Contract Note"
          );
          setFrequencyOfAccountSettlement(
            data.frequency_of_account_settlement || "Quarterly"
          );
          setCity(data.city || city);
          setState(data.state || state);
          setCountry(data.country || country);
          setPep(data.pep || null);
          setEcn(data.ecn || null);
          setRelatedToPep(data.related_to_pep || null);
          setBsdaConfirmation(data.bsda_confirmation || null);
          setSebiAction3years(data.any_sebi_action_last_3_years || "No");
          // setFatca(data.fatca ? true : false);
          setCitizenOfOtherCountry(data.citizen_of_other_country || "No");
          setMappingUccDeclaration(data.mapping_ucc_declaration ? true : false);
          if (data.segment_detail?.length) {
            const segments = {};
            data.segment_detail.forEach((segment) => {
              if (segment.segment === "Capital Market") {
                segments.cash = exchangeSegment.cash || [];
              } else if (segment.segment === "Future and Option") {
                segments.fno = exchangeSegment.fno || [];
              } else if (segment.segment === "Currency Derivative") {
                segments.currency_derivatives =
                  exchangeSegment.currency_derivatives || [];
              } else if (segment.segment === "Commodities") {
                segments.commodities = exchangeSegment.commodities || [];
              } else if (segment.segment === "SLB") {
                segments.slb = exchangeSegment.slb || [];
              }
            });
            setTradingExchangeSegment((prev) => ({
              ...prev,
              ...{
                ...segments,
                selectedAll: data.segment_detail.length >= 4,
              },
            }));
          }
        }
      })
      .catch((err) => {
        console.error("", err);
      });
  }, []);

  useEffect(() => {
    if (permanentAddressSame === "Yes") {
      getUserAddress();
    }
  }, [permanentAddressSame]);

  useEffect(() => {
    let intervalId = null;
    if (
      permanentAddressSame === "Yes" &&
      pincode?.length === 6 &&
      (!city || !state) &&
      pinCodeApiCount < 3
    ) {
      intervalId = setInterval(() => {
        setPinCodeApiCount((count) => count + 1);
        getCityStateFromPin(pincode);
      }, 2000);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [permanentAddressSame, pinCodeApiCount, pincode, city, state]);

  useEffect(() => {
    if (!pinCodeApiCount) return;
    if (pincode?.length === 6) {
      getCityStateFromPin(pincode);
    } else {
      setCity("");
      setState("");
      setCountry("");
    }
  }, [pincode]);

  useEffect(() => {
    if (commPincode?.length === 6) {
      getCityStateFromPin(commPincode, false);
    } else {
      setCommCity("");
      setCommState("");
      setCommCountry("");
    }
  }, [commPincode]);

  useEffect(() => {
    getPEPandECN();
  }, []);

  useEffect(() => {
    const loadPersonalFields = async () => {
      let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
      API_URL_NEW = API_URL_NEW
        ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
        : "";
      try {
        const resp = await axios.get(
          `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_page.signup.api.get_personal_details_page_fields`
        );
        let fieldArr = {};
        const fields = (resp.data?.data?.personal_details_fields || []).map(
          (item) => {
            fieldArr[item.field_name] = "";
            return fieldArr;
          }
        );
        setPersonalValues({
          ...personalValues,
          ...fields[0],
        });
        setPersonalFields(resp.data?.data?.personal_details_fields || []);
      } catch (error) {
        console.error("fields err", error.response);
      }
    };
    loadPersonalFields();
  }, []);

  const changeFieldArr = (arr) => {
    let res = [];
    if (arr?.length > 0) {
      let textInput = arr?.filter((y) => y.field_type === "Data");
      let checkInput = arr?.filter((y) => y.field_type === "Check");
      res = [...textInput, ...checkInput];
    }
    return res;
  };

  // Get Address
  const getUserAddress = () => {
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    axios
      .get(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.address.api.get_verified_address`,
        headers
      )
      .then((result) => {
        const { data } = result;
        setIsAddressChanged(data.data.address_line1?.toUpperCase() || "");
        setIsPincodeChanged(data.data.pincode || "");
        setAddressLine1(data.data.address_line1?.toUpperCase() || "");
        setPinCode(data.data.pincode || "");
      })
      .catch((error) => {});
  };

  const getCityStateFromPin = (pincode, isPermanent = true) => {
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    setIsLoading(true);
    axios
      .post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.address.api.get_data_from_pincode`,
        { pincode },
        headers
      )
      .then((result) => {
        if (result?.data?.data) {
          const { DistrictName, StateName } = result?.data?.data;
          if (isPermanent) {
            setCity(DistrictName);
            setState(StateName);
            setCountry("INDIA");
          } else {
            setCommCity(DistrictName);
            setCommState(StateName);
            setCommCountry("INDIA");
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        const { response } = error;
        if (response?.data?.message) {
          !isPincodeAvail &&
            toast.error(response?.data?.message || "Invalid pincode");
          setIsPincodeAvail(true);
        } else {
          toast.error(API_ERROR_500);
        }
        if (isPermanent) {
          setPinCode("");
          setCity("");
          setState("");
          setCountry("");
        } else {
          setCommPinCode("");
          setCommCity("");
          setCommState("");
          setCommCountry("");
        }
        setIsLoading(false);
      });
  };

  const getPEPandECN = async () => {
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    axios
      .get(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.check_ecn_setting`,
        headers
      )
      .then(() => {
        setAllowedECN(true);
      })
      .catch(() => {
        setAllowedECN(false);
      });
    axios
      .get(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.check_pep_setting`,
        headers
      )
      .then(() => {
        setAllowedPEP(true);
      })
      .catch(() => {
        setAllowedPEP(false);
      });
  };

  const scrollIntoViewHelper = (name) => {
    let el = document.querySelector(`[name="${name}"]`);
    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  const checkAddressModified = () => {
    let isModified = 0;
    if (isAddressChanged.trim() !== addressLine1.trim()) {
      isModified = 1;
    }
    if (isPincodeChanged !== pincode) {
      isModified = 1;
    }
    return isModified;
  };

  const validateCommunicationProof = () => {
    const { type, file1, file2, address_proof_name } = commProof;
    let valid = false;
    if (
      !type ||
      (type === "DrivingLicense" && !file1) ||
      (type === "Other" && (!address_proof_name || !file1)) ||
      (!["DrivingLicense", "Other"].includes(type) && (!file1 || !file2))
    ) {
      valid = true;
    }
    return valid;
  };

  const uploadCommunicationProof = async () => {
    const domain = window.sessionStorage.getItem("portal_domain");
    const API_URL = domain ? domain.substring(0, domain.length - 1) : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    dispatch(setLoading(true));
    const payload = { ...commProof };
    if (
      payload.file1?.type === "application/pdf" ||
      payload.file2?.type === "application/pdf"
    ) {
      payload.file_type = "pdf";
    }
    delete payload["isAddressChanged"];
    if (commProof.type === "Other") {
      try {
        const resp = await axios.post(
          `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.verify_other_correspondence_address`,
          jsonToFormData(payload),
          headers
        );
        const data = resp.data?.data;
        dispatch(setLoading(false));
        setCommAddressLine1(data?.corr_address_line1?.toUpperCase() ?? "");
        setCommPinCode(data?.corr_pincode);
        setCommProof((prev) => {
          return { ...prev, isAddressChanged: false };
        });
      } catch (error) {
        const { response } = error || {};
        dispatch(setLoading(false));
        setCommProof((prev) => {
          return { ...prev, isAddressChanged: false };
        });
        toast.error(response?.data?.message || API_ERROR_500);
      }
    } else {
      delete payload["address_proof_name"];
      try {
        const resp = await axios.post(
          `${API_URL}/api/method/kyc_customizations.apis.kyc_verification.api.verify_correspondence_address`,
          jsonToFormData(payload),
          headers
        );
        const data = resp.data?.data;
        dispatch(setLoading(false));
        setCommAddressLine1(data?.corr_address_line1?.toUpperCase() ?? "");
        setCommPinCode(data?.corr_pincode);
        setCommProof((prev) => {
          return { ...prev, isAddressChanged: false };
        });
      } catch (error) {
        const { response } = error || {};
        dispatch(setLoading(false));
        setCommProof((prev) => {
          return { ...prev, isAddressChanged: false };
        });
        toast.error(response?.data?.message || API_ERROR_500);
      }
    }
  };

  const validateSegment = () => {
    const data = tradingExchangeSegment;
    delete data.selectedAll;
    for (let key in data) {
      if (data[key].length > 0) {
        return false;
      }
    }
    return true;
  };
  let OTHER_AS_OCCUPATION = window.sessionStorage.getItem(
    "other_as_occupation"
  );
  const submitPersonalData = async (event) => {
    event.preventDefault();
    setSubmitted(true);
    let isSubmitable = true;
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    if (validateSegment()) {
      isSubmitable = false;
      scrollIntoViewHelper("segment");
    }
    if (motherName == "") {
      isSubmitable = false;
      scrollIntoViewHelper("motherName");
    }
    if (fatherName == "") {
      isSubmitable = false;
      scrollIntoViewHelper("fatherName");
    }
    if (maritalStatus == "") {
      isSubmitable = false;
      scrollIntoViewHelper("maritalStatus");
    }
    if (permanentAddressSame == null) {
      isSubmitable = false;
      scrollIntoViewHelper("communicationAddress");
    }
    if (stockExperienct == "") {
      isSubmitable = false;
      scrollIntoViewHelper("stockExperienct");
    }
    if (addressLine1 == "") {
      isSubmitable = false;
      scrollIntoViewHelper("address");
    }
    if (pincode == "") {
      isSubmitable = false;
      scrollIntoViewHelper("pincode");
    }
    if (!city || !state) {
      isSubmitable = false;
      scrollIntoViewHelper("pincode");
      setPinCode("");
      // toast.error("Please enter a valid permanent pin code.");
    }
    if (maritalStatus === "Married" && !spouseName.spouse_first_name?.trim()) {
      isSubmitable = false;
      scrollIntoViewHelper("spouse_first_name");
    }
    if (maritalStatus === "Married" && !spouseName.spouse_last_name?.trim()) {
      isSubmitable = false;
      scrollIntoViewHelper("spouse_last_name");
    }
    if (permanentAddressSame == "No" && commAddressLine1 == "") {
      isSubmitable = false;
      scrollIntoViewHelper("commAddressLine1");
    }
    if (permanentAddressSame == "No" && commPincode == "") {
      isSubmitable = false;
      scrollIntoViewHelper("commPincode");
    }
    if (permanentAddressSame == "No" && (commCity == "" || commState == "")) {
      isSubmitable = false;
      scrollIntoViewHelper("commPincode");
      toast.error("Please enter a valid communication pin code.");
    }
    if (pep == null) {
      isSubmitable = false;
      scrollIntoViewHelper("pep");
    }
    if (ecn == null) {
      isSubmitable = false;
      scrollIntoViewHelper("ecn");
    }
    if (bsdaConfirmation == null) {
      isSubmitable = false;
      scrollIntoViewHelper("bsda_confirmation");
    }
    if (!fatca) {
      isSubmitable = false;
      scrollIntoViewHelper("fatca");
    }
    if (!mappingUccDeclaration) {
      isSubmitable = false;
      scrollIntoViewHelper("mappingUccDeclaration");
    }
    // let OTHER_AS_OCCUPATION = window.sessionStorage.getItem("other_as_occupation");
    // if(OTHER_AS_OCCUPATION.includes('Yes')){
    //   if(!occupationName || occupationName == '' && occupation == "Others"){
    //     console.log("FROM HERE")
    //     isSubmitable = false;
    //   }
    // }

    //  else if (!clientCategoryDeclaration) {
    //   isSubmitable = false;
    // }
    if (isSubmitable) {
      const segment = tradingExchangeSegment;
      delete segment.selectedAll;
      let payload = {
        mothers_name: motherName,
        fathers_name: fatherName,
        ...spouseName,
        gender: gender,
        marital_status: maritalStatus,
        permanent_address_changed: isPermanentAddressChange === "Yes" ? 1 : 0,
        is_corr_and_perm_address_same: permanentAddressSame == "Yes" ? 1 : 0,
        address_line1:
          typeof addressLine1 === "object" ? addressLine1[0] : addressLine1,
        address_line2: addressLine2,
        landmark: landmark,
        pincode: typeof pincode === "object" ? pincode[0] : pincode,
        is_address_modified: checkAddressModified(),
        experience_in_stock_market: stockExperienct,
        occupation: occupation,
        annual_income: annualIncome,
        source_of_income: sourceofincome,
        nationality: nationality,
        pep: pep === "Yes" ? "Yes" : "No",
        related_to_pep: relatedToPep === "Yes" ? "Yes" : "No",
        ecn: ecn === "No" ? "Yes" : "No",
        bsda_confirmation: bsdaConfirmation,
        any_sebi_action_last_3_years: sebiAction3years === "Yes" ? "Yes" : "No",
        fatca: fatca,
        other_occupation: occupationName,
        mapping_ucc_declaration: mappingUccDeclaration,
        // client_category_declaration: clientCategoryDeclaration,
        mode_of_receiving_ecn: modeOfReceivingEcn,
        frequency_of_account_settlement: frequencyOfAccountSettlement,
        city,
        state,
        country,
        citizen_of_other_country:
          citizenOfOtherCountry === "Yes" ? "Yes" : "No",
        exc_type: "",
        wish_to_receive_account_statement: wishtoreceiveaccountstatement,
        wish_to_receive_annual_report: wishtoreceiveannualreport,
        like_to_share_email_with_rta: liketoshareemailwithrta,
        easi_allows_bo: easiallowsbo,
        non_issuance_of_delivery_slip: nonissuanceofdeliveryslip,
        segment_detail: segment,
        do_not_wish_to_trade_in_any_segment: isExchangeSegment,
        personal_details: [personalValues],
      };
      dispatch(setLoading(true));
      if (permanentAddressSame === "No") {
        payload["corr_address_line1"] = commAddressLine1;
        payload["corr_pincode"] = commPincode;
        payload["corr_city"] = commCity;
        payload["corr_state"] = commState;
        payload["corr_country"] = commCountry;
      }
      try {
        await axios.post(
          `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.personal_data_verification`,
          payload,
          headers
        );
        toast.success("Personal Data Verification Successful");
        setSubmitted(false);
        removeIsPermanentChange();
        dispatch(getStageScreen());
        dispatch(setLoading(false));
      } catch (error) {
        const { response } = error || {};
        toast.error(response?.data?.message || API_ERROR_500);
        dispatch(setLoading(false));
      }
    }
  };

  const debounceUpdatePersonalDataField = (
    fieldName,
    value,
    isPermanentAddress = false,
    isCommAddress = false
  ) => {
    clearTimeout(debounceTimer);
    const timer = setTimeout(() => {
      updatePersonalDataField(
        fieldName,
        value,
        isPermanentAddress,
        isCommAddress
      );
    }, 500);
    setDebounceTimer(timer);
  };

  const updatePersonalDataField = async (
    fieldName,
    value,
    isPermanentAddress = false,
    isCommAddress = false
  ) => {
    setIsUpdating(true);
    let API_URL_NEW = window.sessionStorage.getItem("portal_domain");
    API_URL_NEW = API_URL_NEW
      ? API_URL_NEW.substring(0, API_URL_NEW.length - 1)
      : "";
    const token = window.sessionStorage.getItem("token");
    const headers = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        Authorization: `Basic ${token}`,
      },
    };
    let obj = {};
    if (isPermanentAddress) {
      obj[fieldName] = value;
      obj["city"] = city;
      obj["state"] = state;
      obj["country"] = country;
    } else if (isCommAddress) {
      obj[fieldName] = value;
      obj["corr_city"] = commCity;
      obj["corr_state"] = commState;
      obj["corr_country"] = commCountry;
    } else {
      obj[fieldName] = value;
    }
    try {
      await axios.post(
        `${API_URL_NEW}/api/method/kyc_customizations.apis.kyc_verification.api.get_update_personal_data`,
        obj,
        headers
      );
      setIsUpdating(false);
    } catch (error) {
      setIsUpdating(false);
    }
  };

  const [permanentAddress, setPermanentAddress] = useState(false);

  const updatePermanentAddress = (value) => {
    setPermanentAddress(value);
  };

  const pushAddressForcefully = () => {
    let index = 0;
    for (let i in pageFlow) {
      if (pageFlow[i] == "Address") {
        index = i;
      }
    }
    dispatch(setAddressForcefullyRedux(index));
  };

  const updateAddressUsingDigilocker = () => {
    dispatch(getDgLocker());
  };

  const onNumberInput = (evt) => {
    let charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
  };

  let API_URL_NEW = window.sessionStorage.getItem("portal_domain");

  const closePermanentAddressModal = () => {
    removeIsPermanentChange();
    setIsPermanentAddressChange("No");
    setPermanentAddress(false);
  };

  const handleExchangeAll = (e) => {
    const { checked } = e.target;
    if (checked) {
      setTradingExchangeSegment({
        cash: exchangeSegment.cash || [],
        fno: exchangeSegment.fno || [],
        currency_derivatives: exchangeSegment.currency_derivatives || [],
        commodities: exchangeSegment.commodities || [],
        debt: exchangeSegment.debt || [],
        slb: exchangeSegment.slb || [],
        selectedAll: true,
      });
    } else {
      setTradingExchangeSegment({
        cash: [],
        fno: [],
        currency_derivatives: [],
        commodities: [],
        debt: [],
        slb: [],
        selectedAll: false,
      });
    }
    setIsExchangeSegment("No");
  };

  function compareExchangeSegment(obj1, obj2) {
    for (let key in obj1) {
      if (
        !(key in obj2) ||
        JSON.stringify(obj1[key]) !== JSON.stringify(obj2[key])
      ) {
        return false;
      }
    }

    return true;
  }
  const handleExchange = (e, key) => {
    const { checked } = e.target;
    if (checked) {
      setTradingExchangeSegment((prev) => {
        const updatedList = {
          ...prev,
          [key]: exchangeSegment[key],
        };
        return {
          ...prev,
          [key]: exchangeSegment[key],
          selectedAll: compareExchangeSegment(exchangeSegment, updatedList),
        };
      });
    } else {
      setTradingExchangeSegment((prev) => ({
        ...prev,
        [key]: [],
        selectedAll: false,
      }));
    }
    setIsExchangeSegment("No");
  };

  const getSegmentName = (key) => {
    const nameObj = {
      cash: "Cash",
      fno: "F&O",
      currency_derivatives: "CD",
      commodities: "Com",
      debt: "Debt",
      slb: "SLB",
    };
    return nameObj[key];
  };

  const getSegmentTooltipName = (key) => {
    const nameObj = {
      cash: "Equity",
      fno: "Future & Options",
      currency_derivatives: "Currency Derivatives",
      commodities: "Commodities",
      debt: "Debt",
    };
    return nameObj[key];
  };

  const renderSegmentNameTooltip = (props) => {
    return (
      <Tooltip
        id={`tooltip-${props.key}`}
        {...props}
      >
        {getSegmentTooltipName(props.key)}
      </Tooltip>
    );
  };

  // TODO : Need to write clean code BSDA option
  useEffect(() => {
    if (API_URL_NEW == "https://consortium.brkscmcj.in/") {
      setTimeout(() => {
        setBsdaConfirmation("No");
      }, 500);
    }
  }, []);

  return (
    <React.Fragment>
      <Modal
        show={permanentAddress}
        onHide={() => closePermanentAddressModal()}
      >
        <Modal.Header closeButton>
          <Modal.Title style={{ color: inputLabelColor }}>
            Change Address
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-4 my-2">
              <Button
                title="Digilocker"
                handleClick={() => updateAddressUsingDigilocker()}
              />
            </div>
            <div className="col-md-8 my-2">
              <Button
                title="Upload Address Proof"
                handleClick={() => pushAddressForcefully()}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-warning btn-sm"
            onClick={() => closePermanentAddressModal()}
            type="button"
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
      <div className="col-md-10">
        <form onSubmit={submitPersonalData}>
          <div className="row">
            <div className="col-md-12">
              <Title title="Personal Data" />
            </div>
            <div className="col-md-6">
              <TextInput
                label="Mother's Full Name*"
                name="motherName"
                placeholder="Enter Mother Name"
                value={motherName}
                onChange={({ target }) => {
                  const value = target.value?.toUpperCase();
                  setMotherName(value);
                  debounceUpdatePersonalDataField("mothers_name", value);
                }}
                error={
                  submitted && motherName == "" ? "Mother name is required" : ""
                }
              />
            </div>
            <div className="col-md-6">
              <TextInput
                label="Father's Full Name*"
                name="fatherName"
                placeholder="Enter Father Name"
                value={fatherName}
                onChange={({ target }) => {
                  const value = target.value?.toUpperCase();
                  setFatherName(value);
                  debounceUpdatePersonalDataField("fathers_name", value);
                }}
                error={
                  submitted && fatherName == "" ? "Father name is required" : ""
                }
              />
            </div>
            <div className="col-md-6">
              {/* <label>Gender*</label> */}
              <Label label="Gender*" />
              <div
                onChange={(e) => {
                  setGender(e.target.value);
                  debounceUpdatePersonalDataField("gender", e.target.value);
                }}
              >
                <input
                  type="radio"
                  value="Male"
                  checked={gender == "Male"}
                  name="gender"
                />{" "}
                <span style={{ color: inputLabelColor }}>Male</span>{" "}
                <input
                  type="radio"
                  value="Female"
                  checked={gender == "Female"}
                  name="gender"
                />{" "}
                <span style={{ color: inputLabelColor }}>Female</span>{" "}
                {/* <input
                  type="radio"
                  value="Transgender"
                  checked={gender == "Transgender"}
                  name="gender"
                />{" "}
                <span style={{ color: inputLabelColor }}>Transgender</span>{" "} */}
              </div>
            </div>
            <div className="col-md-6">
              <Label label="Marital Status*" />
              <div
                onChange={(e) => {
                  if (e.target.value === "Single") {
                    setSpouseName({
                      spouse_first_name: "",
                      spouse_last_name: "",
                    });
                  }
                  setMaritalStatus(e.target.value);
                  debounceUpdatePersonalDataField(
                    "marital_status",
                    e.target.value
                  );
                }}
              >
                <input
                  type="radio"
                  value="Single"
                  checked={maritalStatus == "Single"}
                  name="maritalStatus"
                />{" "}
                <span
                  style={{ color: inputLabelColor }}
                  className="mx-1"
                >
                  Single
                </span>{" "}
                <input
                  type="radio"
                  value="Married"
                  checked={maritalStatus == "Married"}
                  name="maritalStatus"
                />{" "}
                <span
                  style={{ color: inputLabelColor }}
                  className="mx-1"
                >
                  Married
                </span>{" "}
              </div>
              <span style={{ fontSize: 12, color: inputError }}>
                {submitted && maritalStatus == ""
                  ? "Marital Status's required"
                  : ""}
              </span>
            </div>
            {maritalStatus === "Married" && (
              <>
                <div className="col-md-6">
                  <TextInput
                    label="Spouse First Name*"
                    name="spouse_first_name"
                    placeholder="Enter first name"
                    value={spouseName.spouse_first_name}
                    onChange={({ target }) => {
                      const value = target.value?.toUpperCase();
                      setSpouseName({
                        ...spouseName,
                        spouse_first_name: value,
                      });
                      debounceUpdatePersonalDataField(
                        "spouse_first_name",
                        value
                      );
                    }}
                    error={
                      submitted &&
                      !spouseName.spouse_first_name &&
                      "First name is required"
                    }
                  />
                </div>
                <div className="col-md-6">
                  <TextInput
                    label="Spouse Last Name*"
                    name="spouse_last_name"
                    placeholder="Enter last name"
                    value={spouseName.spouse_last_name}
                    onChange={({ target }) => {
                      const value = target.value?.toUpperCase();
                      setSpouseName({ ...spouseName, spouse_last_name: value });
                      debounceUpdatePersonalDataField(
                        "spouse_last_name",
                        value
                      );
                    }}
                    error={
                      submitted &&
                      !spouseName.spouse_last_name &&
                      "Last name is required"
                    }
                  />
                </div>
              </>
            )}
            <div className="col-md-12">
              {API_URL_NEW != "https://scmcbrd.in/" && (
                <>
                  <Label label="Communication Address" />
                  <p>
                    <label style={{ fontSize: 11, color: inputLabelColor }}>
                      {" "}
                      Is communication address same as Permanent Address proof
                      submitted?*
                    </label>

                    <div
                      onChange={(e) => {
                        setPermanentAddressSame(e.target.value);
                        debounceUpdatePersonalDataField(
                          "is_corr_and_perm_address_same",
                          e.target.value
                        );
                      }}
                    >
                      <input
                        type="radio"
                        value="Yes"
                        checked={permanentAddressSame == "Yes"}
                        name="communicationAddress"
                      />{" "}
                      <span
                        style={{ color: inputLabelColor }}
                        className="mx-1"
                      >
                        Yes
                      </span>{" "}
                      <input
                        type="radio"
                        value="No"
                        checked={permanentAddressSame == "No"}
                        name="communicationAddress"
                      />{" "}
                      <span
                        style={{ color: inputLabelColor }}
                        className="mx-1"
                      >
                        No
                      </span>{" "}
                    </div>
                    {submitted && permanentAddressSame == null && (
                      <span style={{ fontSize: 12, color: inputError }}>
                        Please submit communication address.
                      </span>
                    )}
                  </p>
                </>
              )}
              {permanentAddressSame == "No" && (
                <div className="row border pb-1">
                  <h6 className="mt-2">Communication Address</h6>
                  <div className="col-md-12">
                    <div className="row">
                      <div className="col-md-6">
                        <Label
                          label="Address Type*"
                          className="my-2"
                        />
                        <select
                          name="type"
                          className="form-select mt-2"
                          onChange={({ target }) => {
                            setCommProof((prev) => {
                              return {
                                ...prev,
                                type: target.value,
                                file1: "",
                                file2: "",
                                address_proof_name: "",
                              };
                            });
                            setCommAddressLine1("");
                            setCommPinCode("");
                          }}
                        >
                          {addressTypes.map((option) => {
                            return (
                              <option
                                key={option.name}
                                value={option.value}
                              >
                                {option.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    {commProof.type && commProof.type === "Other" && (
                      <div className="row mb-1">
                        <div className="col-md-6">
                          <TextInput
                            label="Proof Type*"
                            className="form-control mt-2"
                            value={commProof.address_proof_name}
                            onChange={({ target }) =>
                              setCommProof((prev) => {
                                return {
                                  ...prev,
                                  address_proof_name: target.value,
                                };
                              })
                            }
                          />
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-md-6">
                        <Label
                          label="Front Image (jpg, png, pdf)*"
                          className="my-2"
                        />
                        <input
                          key={commProof.type}
                          name="file1"
                          type="file"
                          accept="image/*,application/pdf"
                          className="form-control"
                          onChange={({ target }) =>
                            setCommProof((prev) => {
                              return { ...prev, file1: target.files[0] };
                            })
                          }
                        />
                      </div>
                      <div className="col-md-6">
                        <Label
                          label={`Back Image (jpg, png, pdf)${
                            ["DrivingLicense", "Other"].includes(commProof.type)
                              ? ""
                              : "*"
                          }`}
                          className="my-2"
                        />
                        <input
                          key={commProof.type}
                          name="file2"
                          type="file"
                          accept="image/*,application/pdf"
                          className="form-control"
                          onChange={({ target }) =>
                            setCommProof((prev) => {
                              return { ...prev, file2: target.files[0] };
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="mt-4 text-end">
                      <Button
                        title="Upload"
                        type="button"
                        disabled={isLoading || validateCommunicationProof()}
                        name="Submit"
                        handleClick={uploadCommunicationProof}
                      ></Button>
                    </div>
                  </div>
                  <div className="col-md-12">
                    <TextArea
                      name="commAddressLine1"
                      label="Address"
                      value={commAddressLine1}
                      onChange={({ target }) => {
                        const value = target.value?.toUpperCase();
                        setCommAddressLine1(value);
                        debounceUpdatePersonalDataField(
                          "corr_address_line1",
                          value
                        );
                      }}
                      disabled={commProof.isAddressChanged}
                      className="form-control"
                      placeholder="Enter Address Here"
                      marginTop="mt-3"
                    />
                  </div>
                  <div className="col-md-6 mb-2">
                    <TextInput
                      name="commPincode"
                      label="Pin Code"
                      type="text"
                      value={commPincode}
                      onChange={(e) => {
                        setCommPinCode(e.target.value);
                        debounceUpdatePersonalDataField(
                          "corr_pincode",
                          e.target.value,
                          false,
                          true
                        );
                      }}
                      disabled={commProof.isAddressChanged}
                      className="form-control"
                      placeholder="Pin Code"
                      maxLength={6}
                      marginTop="mt-3"
                    />
                    {commCity && commState != "" && (
                      <span
                        className="text-dark"
                        style={{
                          fontSize: 11,
                          textTransform: "uppercase",
                          color: inputLabelColor,
                        }}
                      >
                        {commCity && <span>{commCity}, </span>}
                        {commState && <span>{commState}, </span>}
                        <span>{commCountry}</span>
                      </span>
                    )}
                  </div>
                </div>
              )}
              <div className="my-4" />
              {/* Permanent Address Same Lines Field */}
              {permanentAddressSame && (
                <div className="row border pb-1">
                  <h6 className="mt-2">Permanent Address</h6>
                  <div className="col-md-12">
                    <TextArea
                      name="address"
                      label="Address"
                      value={addressLine1}
                      onChange={({ target }) => {
                        const value = target.value?.toUpperCase();
                        setAddressLine1(value);
                        debounceUpdatePersonalDataField("address_line1", value);
                      }}
                      disabled={false}
                      className="form-control"
                      placeholder="Enter Address Here"
                      error={
                        submitted &&
                        (addressLine1 === "" || addressLine1.trim() === "")
                          ? "Address is required"
                          : ""
                      }
                      marginTop="mt-2"
                    />
                  </div>
                  <div className="col-md-6">
                    <TextInput
                      name="pincode"
                      label="Pin Code"
                      type="text"
                      value={pincode}
                      onChange={(e) => {
                        setPinCode(e.target.value);
                        debounceUpdatePersonalDataField(
                          "pincode",
                          e.target.value,
                          true
                        );
                      }}
                      disabled={false}
                      // disabled={permanentAddressSame == "Yes"}
                      className="form-control"
                      placeholder="Pin Code"
                      maxLength={6}
                      error={
                        submitted && (pincode === "" || pincode.trim() === "")
                          ? "Pin Code is required"
                          : ""
                      }
                    />
                    {/* {isPincodeAvail && (
                    <>
                      <TextInput
                        name="city"
                        label="City"
                        type="text"
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        onBlur={(e) => {
                          debounceUpdatePersonalDataField("city", e.target.value, true);
                        }}
                        className="form-control"
                        placeholder="City"
                        error={submitted && city == "" ? "City's required" : ""}
                      />
                      <TextInput
                        name="state"
                        label="State"
                        type="text"
                        value={state}
                        onChange={(e) => setState(e.target.value)}
                        onBlur={(e) => {
                          debounceUpdatePersonalDataField(
                            "state",
                            e.target.value,
                            true
                          );
                        }}
                        className="form-control"
                        placeholder="State"
                        error={
                          submitted && state == "" ? "State's required" : ""
                        }
                      />
                    </>
                  )} */}
                    {pincode && (
                      <span
                        className="text-dark"
                        style={{
                          fontSize: 11,
                          textTransform: "uppercase",
                          color: inputLabelColor,
                        }}
                      >
                        {city && <span>{city}, </span>}
                        {state && <span>{state}, </span>}
                        {country && <span>{country} </span>}
                      </span>
                    )}
                  </div>
                </div>
              )}
              <Label label="Permanent Address" />
              <label style={{ fontSize: 11, color: inputLabelColor }}>
                {" "}
                Do you wish to update your permanent address.?
              </label>
              <div
                onChange={(e) => {
                  setIsPermanentAddressChange(e.target.value);
                  if (e.target.value === "No") return;
                  saveIsPermanentChange(e.target.value);
                  if (digilocker) {
                    pushAddressForcefully();
                  } else {
                    updatePermanentAddress(e.target.value);
                  }
                }}
              >
                <input
                  type="radio"
                  value={"Yes"}
                  checked={isPermanentAddressChange === "Yes"}
                  name="permanentAddress"
                />{" "}
                <span
                  style={{ color: inputLabelColor }}
                  className="mx-1"
                >
                  Yes
                </span>{" "}
                <input
                  type="radio"
                  value={"No"}
                  checked={isPermanentAddressChange === "No"}
                  name="permanentAddress"
                />{" "}
                <span
                  style={{ color: inputLabelColor }}
                  className="mx-1"
                >
                  No
                </span>{" "}
              </div>
              <div className="row mt-3">
                <div className="col-md-6">
                  <TextInput
                    name="stockExperienct"
                    label="Number of years of Experience in stock / commodity market*"
                    type="text"
                    placeholder="Enter Experience Here"
                    value={stockExperienct}
                    maxLength={2}
                    onChange={(e) => {
                      setStockExperience(e.target.value);
                      debounceUpdatePersonalDataField(
                        "experience_in_stock_market",
                        e.target.value
                      );
                    }}
                    onKeyPress={onNumberInput}
                    className="form-control"
                    style={{
                      borderColor:
                        submitted && stockExperienct == "" ? "red" : "",
                    }}
                    error={
                      submitted && stockExperienct == ""
                        ? "Please enter your experience"
                        : ""
                    }
                  />
                  {/* {submitted && stockExperienct == "" && (
                <span style={{ fontSize: 12, color: inputError }}>
                  Please enter your experience
                </span>
              )} */}
                </div>
                <div className="col-md-6">
                  <Label label="Occupation details*" />
                  <div style={{ marginBottom: "1.1em" }}></div>
                  {/* <div
                onChange={(e) => {
                  setOccupation(e.target.value);
                  debounceUpdatePersonalDataField("occupation", e.target.value);
                }}
              >
                <span>
                  <input
                    type="radio"
                    value="Salaried"
                    checked={occupation == "Salaried"}
                    name="occupation"
                  />{" "}
                  <span style={{ color: inputLabelColor }}>Salaried</span>
                </span>
                <span>
                  <input
                    type="radio"
                    value="Business"
                    checked={occupation == "Business"}
                    name="occupation"
                  />{" "}
                  <span style={{ color: inputLabelColor }}>Business</span>
                </span>{" "}
                <span>
                  <input
                    type="radio"
                    value="Housewife"
                    checked={occupation == "Housewife"}
                    name="occupation"
                  />{" "}
                  <span style={{ color: inputLabelColor }}>Housewife</span>
                </span>{" "}
                <span>
                  <input
                    type="radio"
                    value="Others"
                    checked={occupation == "Others"}
                    name="occupation"
                  />{" "}
                  <span style={{ color: inputLabelColor }}>Others</span>
                </span>
              </div> */}
                  <select
                    onChange={(e) => {
                      setOccupation(e.target.value);
                      debounceUpdatePersonalDataField(
                        "occupation",
                        e.target.value
                      );
                    }}
                    value={occupation}
                    className="form-select"
                  >
                    <option>Private Sector</option>
                    <option>Public Sector</option>
                    <option>Government Sector</option>
                    <option>Professional</option>
                    <option>Agriculturist</option>
                    <option>Business</option>
                    {/* <option>Self Employed</option> */}
                    <option>Retired</option>
                    <option>Housewife</option>
                    <option>Student</option>
                    {OTHER_AS_OCCUPATION.includes("Yes") && (
                      <option>Others</option>
                    )}
                  </select>
                  {OTHER_AS_OCCUPATION.includes("Yes") &&
                    occupation == "Others" && (
                      <>
                        <input
                          type="text"
                          onChange={(e) => setOccupationName(e.target.value)}
                          value={occupationName}
                          placeholder="Please enter occupation"
                          className="form-control"
                        />
                        {submitted && !occupationName && (
                          <span style={{ fontSize: 12, color: inputError }}>
                            Please enter occupation name here
                          </span>
                        )}
                      </>
                    )}
                </div>
                <div className="col-md-6">
                  <Label label="Annual Income Details*" />
                  <select
                    onChange={(e) => {
                      setAnnualIncome(e.target.value);
                      debounceUpdatePersonalDataField(
                        "annual_income",
                        e.target.value
                      );
                    }}
                    value={annualIncome}
                    className="form-select"
                  >
                    <option>Upto 1 Lakh</option>
                    <option>1-5 Lakh</option>
                    <option>Above 5-10 Lakh</option>
                    <option>Above 10-25 Lakh</option>
                    <option>Above 25 Lakh</option>
                  </select>
                </div>
                {/* <div className="col-md-6">
                            <lable>Source of Income</lable>
                            <select
                              onChange={(e) =>
                                setSourceofincome(e.target.value)
                              }
                              value={sourceofincome}
                              className="form-control"
                            >
                              <option value="">None</option>
                              <option>Income from Salary</option>
                              <option>Income from House Property</option>
                              <option>Income from Capital Gains/Loss</option>
                              <option>
                                Income from Business and Profession
                              </option>
                              <option>Income from Other Sources</option>
                            </select>
                          </div> */}
                <div className="col-md-6">
                  {/* <label>Nationality</label>
              <input
                type="text"
                disabled={true}
                value={nationality}
                className="form-control"
              /> */}
                  <TextInput
                    label="Nationality"
                    type="text"
                    disabled={true}
                    value={nationality}
                  />
                </div>
                <div className="col-md-6">
                  <Label label="Mode of Receiving ECN*" />
                  <select
                    onChange={(e) => {
                      setModeOfReceivingEcn(e.target.value);
                      debounceUpdatePersonalDataField(
                        "mode_of_receiving_ecn",
                        e.target.value
                      );
                    }}
                    value={modeOfReceivingEcn}
                    className="form-select"
                  >
                    <option>Electronic Contract Note</option>
                    <option>Physical</option>
                  </select>
                  {API_URL_NEW == "https://scmcbrke.in/" &&
                    modeOfReceivingEcn == "Physical" && (
                      <div style={{ fontSize: 12, color: inputError }}>
                        Please contact your broker
                      </div>
                    )}
                </div>
                <div className="col-md-6">
                  <Label label="Frequency of account settlement*" />
                  <select
                    onChange={(e) => {
                      setFrequencyOfAccountSettlement(e.target.value);
                      debounceUpdatePersonalDataField(
                        "frequency_of_account_settlement",
                        e.target.value
                      );
                    }}
                    value={frequencyOfAccountSettlement}
                    className="form-select"
                  >
                    {API_URL_NEW === "https://scmcbrkd.in/" && (
                      <>
                        <option>Monthly</option>
                        <option>Quarterly</option>
                      </>
                    )}
                    {API_URL_NEW === "https://scmcbrke.in/" && (
                      <option>Quarterly</option>
                    )}
                    {API_URL_NEW != "https://scmcbrkd.in/" &&
                      API_URL_NEW != "https://scmcbrke.in/" && (
                        <>
                          <option>Daily</option>
                          <option>Monthly</option>
                          <option>Quarterly</option>
                        </>
                      )}
                  </select>
                </div>
                <div className="col-md-12">
                  <div className="table-responsive">
                    <Label label="TRADING PREFERENCES" />
                    <table
                      name="segment"
                      className="mt-1"
                    >
                      <tr
                        style={{
                          color: inputLabelColor,
                          background: "#f5f5f5",
                        }}
                      >
                        <th className="text-center">Exchanges</th>
                        {Object.keys(exchangeSegment).map((key, index) => {
                          if (exchangeSegment[key].length > 0) {
                            return (
                              <th
                                key={index}
                                className="text-center font-weight-bold"
                              >
                                {exchangeSegment[key].join(", ")}
                              </th>
                            );
                          }
                        })}
                        {/* {exchangeSegment.e1.length > 0 && (
                          <th
                            className="text-center"
                            colSpan={exchangeSegment.s1.length}
                          >
                            {getSegmentTitle(exchangeSegment.e1)}
                          </th>
                        )}
                        {exchangeSegment.e2.length > 0 && (
                          <th
                            className="text-center"
                            colSpan={exchangeSegment.s2.length}
                          >
                            {getSegmentTitle(exchangeSegment.e2)}
                          </th>
                        )} */}
                      </tr>
                      <tr
                        style={{
                          color: inputLabelColor,
                          background: "#f5f5f5",
                        }}
                      >
                        <td className="text-center font-weight-bold">
                          All Segments
                        </td>
                        {Object.keys(exchangeSegment).map((key, index) => {
                          if (exchangeSegment[key].length > 0) {
                            return (
                              <td
                                key={index}
                                className="text-center font-weight-bold"
                              >
                                <OverlayTrigger
                                  placement="top"
                                  delay={{ show: 250, hide: 400 }}
                                  overlay={(props) =>
                                    renderSegmentNameTooltip({ ...props, key })
                                  }
                                >
                                  <span>{getSegmentName(key)}</span>
                                </OverlayTrigger>
                              </td>
                            );
                          }
                        })}
                        {/* {exchangeSegment.e1.length > 0 &&
                          exchangeSegment.s1.map((item) => (
                            <td className="text-center font-weight-bold">
                              {getSegmentName(item)}
                            </td>
                          ))}
                        {exchangeSegment.e2.length > 0 &&
                          exchangeSegment.s2.map((item) => (
                            <td className="text-center font-weight-bold">
                              {getSegmentName(item)}
                            </td>
                          ))} */}
                      </tr>
                      <tr>
                        <td className="text-center">
                          <input
                            type="checkbox"
                            value={tradingExchangeSegment.selectedAll}
                            onChange={(e) => handleExchangeAll(e)}
                            checked={tradingExchangeSegment.selectedAll}
                          />
                        </td>
                        {Object.keys(exchangeSegment).map((key, index) => {
                          if (exchangeSegment[key].length > 0) {
                            return (
                              <td
                                key={index}
                                className="text-center font-weight-bold"
                              >
                                {!!exchangeSegment[key]?.length && (
                                  <input
                                    type="checkbox"
                                    value={key}
                                    onChange={(e) => handleExchange(e, key)}
                                    checked={
                                      tradingExchangeSegment[key]?.length
                                    }
                                  />
                                )}
                              </td>
                            );
                          }
                        })}
                        {/* {exchangeSegment.e1.length > 0 &&
                          exchangeSegment.s1.map((item) => (
                            <td className="text-center">
                              <input
                                type="checkbox"
                                value={item}
                                onChange={(e) => handleExchange(e, item, "s1")}
                                checked={tradingExchangeSegment.s1.includes(
                                  item
                                )}
                              />
                            </td>
                          ))}
                        {exchangeSegment.e2.length > 0 &&
                          exchangeSegment.s2.map((item) => (
                            <td className="text-center">
                              <input
                                type="checkbox"
                                value={item}
                                onChange={(e) => handleExchange(e, item, "s2")}
                                checked={tradingExchangeSegment.s2.includes(
                                  item
                                )}
                              />
                            </td>
                          ))} */}
                      </tr>
                    </table>
                    {/* <table name="segment">
                      <tr style={{ color: inputLabelColor }}>
                        <th>Segment</th>
                        {isShowFieldSegment("cash") && <th>Capital Market</th>}
                        {isShowFieldSegment("fno") && <th>Future And Option</th>}
                        {isShowFieldSegment("currency_derivatives") && (
                          <th>Currency Derivative</th>
                        )}
                        {isShowFieldSegment("commodities") && <th>Commodities</th>}
                        {isShowFieldSegment("slb") && <th>SLB</th>}
                      </tr>
                      {exchangeSegment.map((item, index) => {
                        if (isShowFieldExcahnge(item)) {
                          return (
                            <tr>
                              <th>{item.exchange}</th>
                              {isShowFieldSegment("cash") && (
                                <td>
                                  {item?.cash == 1 && (
                                    <input
                                      type="checkbox"
                                      checked={getCheckboxValue(
                                        item.exchange,
                                        "cash",
                                        index
                                      )}
                                      disabled={
                                        API_URL_NEW == "https://scmcbrkd.in/" &&
                                        (item.exchange == "NSE" || item.exchange == "BSE")
                                      }
                                      onChange={() => {
                                        setCheckboxValue(item.exchange, "cash", index);
                                      }}
                                    />
                                  )}
                                </td>
                              )}
                              {isShowFieldSegment("fno") && (
                                <td>
                                  {item?.fno == 1 && (
                                    <input
                                      type="checkbox"
                                      checked={getCheckboxValue(
                                        item.exchange,
                                        "fno",
                                        index
                                      )}
                                      onChange={() => {
                                        setCheckboxValue(item.exchange, "fno", index);
                                      }}
                                    />
                                  )}
                                </td>
                              )}
                              {isShowFieldSegment("currency_derivatives") && (
                                <td>
                                  {item?.currency_derivatives == 1 && (
                                    <input
                                      type="checkbox"
                                      checked={getCheckboxValue(
                                        item.exchange,
                                        "currency_derivatives",
                                        index
                                      )}
                                      onChange={() => {
                                        setCheckboxValue(
                                          item.exchange,
                                          "currency_derivatives",
                                          index
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                              )}
                              {isShowFieldSegment("commodities") && (
                                <td>
                                  {item?.commodities == 1 && (
                                    <input
                                      type="checkbox"
                                      checked={getCheckboxValue(
                                        item.exchange,
                                        "commodities",
                                        index
                                      )}
                                      onChange={() => {
                                        setCheckboxValue(
                                          item.exchange,
                                          "commodities",
                                          index
                                        );
                                      }}
                                    />
                                  )}
                                </td>
                              )}
                              {isShowFieldSegment("slb") && (
                                <td>
                                  {item?.slb == 1 && (
                                    <input
                                      type="checkbox"
                                      checked={getCheckboxValue(
                                        item.exchange,
                                        "slb",
                                        index
                                      )}
                                      onChange={() => {
                                        setCheckboxValue(item.exchange, "slb", index);
                                      }}
                                    />
                                  )}
                                </td>
                              )}
                            </tr>
                          );
                        }
                      })}
                    </table> */}
                    {submitted && validateSegment() && (
                      <div style={{ fontSize: 12, color: inputError }}>
                        Please select atleast one Segment.
                      </div>
                    )}
                  </div>
                </div>
                {/* <div className="form-group col-md-12 mt-3">
                  <label>
                    If you do not wish to trade in any of segments / Mutual
                    Fund, please confirm here.
                  </label>
                  <input
                    className="form-checkbox mx-2 mt-1"
                    type="checkbox"
                    onClick={handleNoSegmentInput}
                    checked={isExchangeSegment === "Yes"}
                  />
                </div> */}
                <div className="mt-3">
                  {changeFieldArr(personalFields).map((item, index) => {
                    return (
                      <div
                        className="col-md-12"
                        key={index}
                      >
                        {item.field_type === "Check" ? (
                          <div className="mt-3">
                            <input
                              name={item.field_name}
                              type="checkbox"
                              value={personalValues[item.field_name] || ""}
                              onChange={({ target }) =>
                                setPersonalValues({
                                  ...personalValues,
                                  [item.field_name]: target.checked,
                                })
                              }
                              required={item.required}
                            />
                            &nbsp;&nbsp;
                            <span
                              className="form-check-label"
                              style={{ color: inputLabelColor }}
                            >
                              {item.field_label}
                            </span>
                          </div>
                        ) : (
                          <div className="form-group col-md-6">
                            <label>{item.field_label}</label>
                            <input
                              className="form-control"
                              name={item.field_name}
                              placeholder={`Enter ${item.field_name}`}
                              value={personalValues[item.field_name]}
                              onChange={({ target }) =>
                                setPersonalValues({
                                  ...personalValues,
                                  [item.field_name]: target.value,
                                })
                              }
                              required={item.required}
                            />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
                <div className="col-md-12 mt-3">
                  <p style={{ color: inputLabelColor }}>
                    Are you related to a Politically Exposed Person (PEP)?*{" "}
                    <input
                      type="radio"
                      name="pep"
                      onClick={() => {
                        setPep("Yes");
                        debounceUpdatePersonalDataField("pep", "Yes");
                      }}
                      checked={pep === "Yes"}
                    />{" "}
                    Yes{" "}
                    <input
                      type="radio"
                      name="pep"
                      onClick={() => {
                        setPep("No");
                        debounceUpdatePersonalDataField("pep", "No");
                      }}
                      checked={pep === "No"}
                    />{" "}
                    No
                    {!allowedPEP && pep == "Yes" && (
                      <div style={{ fontSize: 12, color: inputError }}>
                        Please contact your broker
                      </div>
                    )}
                    {submitted && pep == null && (
                      <div style={{ fontSize: 12, color: inputError }}>
                        Please select one option.
                      </div>
                    )}
                  </p>
                </div>
                {/* <div className="col-md-12">
              <p style={{ color: inputLabelColor }}>
                Are you related to PEP*{" "}
                <input
                  type="radio"
                  name="related_to_pep"
                  onClick={() => {
                    setRelatedToPep("Yes");
                    debounceUpdatePersonalDataField("related_to_pep", "Yes");
                  }}
                  checked={relatedToPep === "Yes"}
                />{" "}
                Yes{" "}
                <input
                  type="radio"
                  name="related_to_pep"
                  onClick={() => {
                    setRelatedToPep("No");
                    debounceUpdatePersonalDataField("related_to_pep", "No");
                  }}
                  checked={relatedToPep === "No"}
                />{" "}
                No
                {submitted && relatedToPep == null && (
                  <div style={{ fontSize: 12, color: inputError }}>
                    Please select one option.
                  </div>
                )}
              </p>
            </div> */}
                <div className="col-md-12">
                  <p style={{ color: inputLabelColor }}>
                    Electronic Contract Note confirmation on email*{" "}
                    <input
                      type="radio"
                      name="ecn"
                      onClick={() => {
                        setEcn("Yes");
                        debounceUpdatePersonalDataField("ecn", "Yes");
                      }}
                      checked={ecn === "Yes"}
                    />{" "}
                    Yes{" "}
                    <input
                      type="radio"
                      name="ecn"
                      onClick={() => {
                        setEcn("No");
                        debounceUpdatePersonalDataField("ecn", "No");
                      }}
                      checked={ecn === "No"}
                    />{" "}
                    No
                    {!allowedECN && ecn == "Yes" && (
                      <div style={{ fontSize: 12, color: inputError }}>
                        Please contact your broker
                      </div>
                    )}
                    {submitted && ecn == null && (
                      <div style={{ fontSize: 12, color: inputError }}>
                        Please select one option.
                      </div>
                    )}
                  </p>
                </div>
                <div className="col-md-12">
                  <p style={{ color: inputLabelColor }}>
                    {API_URL_NEW == "https://scmcbrke.in/"
                      ? "I Don't want to open BSDA account. keep it normal account."
                      : "BSDA confirmation for Demat*"}{" "}
                    <input
                      type="radio"
                      name="any_sebi_action_last_3_years"
                      onClick={() => {
                        setBsdaConfirmation(
                          API_URL_NEW == "https://scmcbrke.in/" ? "No" : "Yes"
                        );
                        debounceUpdatePersonalDataField(
                          "any_sebi_action_last_3_years",
                          API_URL_NEW == "https://scmcbrke.in/" ? "No" : "Yes"
                        );
                      }}
                      // disabled={API_URL_NEW == "https://scmcbrkd.in/"}
                      checked={
                        API_URL_NEW == "https://scmcbrke.in/"
                          ? bsdaConfirmation == "No"
                          : bsdaConfirmation == "Yes"
                      }
                    />{" "}
                    Yes{" "}
                    {API_URL_NEW != "https://scmcbrke.in/" && (
                      <>
                        <input
                          type="radio"
                          name="any_sebi_action_last_3_years"
                          // disabled={API_URL_NEW == "https://scmcbrkd.in/"}
                          onClick={() => {
                            setBsdaConfirmation("Opt out");
                            debounceUpdatePersonalDataField(
                              "any_sebi_action_last_3_years",
                              "Opt out"
                            );
                          }}
                          checked={bsdaConfirmation == "Opt out"}
                        />{" "}
                        Opt out{" "}
                      </>
                    )}
                    <input
                      type="radio"
                      // disabled={API_URL_NEW == "https://scmcbrkd.in/"}
                      name="any_sebi_action_last_3_years"
                      onClick={() => {
                        setBsdaConfirmation(
                          API_URL_NEW == "https://scmcbrke.in/" ? "Yes" : "No"
                        );
                        debounceUpdatePersonalDataField(
                          "any_sebi_action_last_3_years",
                          API_URL_NEW == "https://scmcbrke.in/" ? "Yes" : "No"
                        );
                      }}
                      checked={
                        API_URL_NEW == "https://scmcbrke.in/"
                          ? bsdaConfirmation == "Yes"
                          : bsdaConfirmation == "No"
                      }
                    />{" "}
                    No
                    {submitted && bsdaConfirmation == null && (
                      <div style={{ fontSize: 12, color: inputError }}>
                        Please select one option.
                      </div>
                    )}
                    {API_URL_NEW == "https://scmcbrke.in/" &&
                      bsdaConfirmation == "Yes" && (
                        <div style={{ fontSize: 12, color: inputError }}>
                          Please contact brocker
                        </div>
                      )}
                  </p>
                </div>
                <div className="col-md-12">
                  <p style={{ color: inputLabelColor }}>
                    Any action/proceedings initiated/pending/taken by SEBI/
                    Stockexchange/any authority against applicant/constituent in
                    last 3 years.{" "}
                    <input
                      type="radio"
                      name="bsda_confirmation"
                      onClick={() => {
                        setSebiAction3years("Yes");
                        debounceUpdatePersonalDataField(
                          "bsda_confirmation",
                          "Yes"
                        );
                      }}
                      checked={sebiAction3years == "Yes"}
                    />{" "}
                    Yes{" "}
                    <input
                      type="radio"
                      name="bsda_confirmation"
                      onClick={() => {
                        setSebiAction3years("No");
                        debounceUpdatePersonalDataField(
                          "bsda_confirmation",
                          "No"
                        );
                      }}
                      checked={sebiAction3years == "No"}
                    />{" "}
                    No
                  </p>
                </div>
                <div className="col-md-12 my-2">
                  <p style={{ color: inputLabelColor, margin: 0 }}>
                    <input
                      name="fatca"
                      type="checkbox"
                      onClick={() => {
                        setFatca(!fatca);
                        debounceUpdatePersonalDataField(
                          "fatca",
                          !fatca ? 1 : 2
                        );
                      }}
                      checked={fatca}
                      disabled
                    />{" "}
                    FATCA declaration
                  </p>
                  {submitted && !fatca && (
                    <div style={{ fontSize: 12, color: inputError }}>
                      This option is mandatory.
                    </div>
                  )}
                </div>
                {fatca && (
                  <div className="col-md-12">
                    <p style={{ color: inputLabelColor }}>
                      Citizen of country other than India?{" "}
                      <input
                        type="radio"
                        name="citigenofcountry"
                        onClick={() => {
                          setCitizenOfOtherCountry("Yes");
                          debounceUpdatePersonalDataField(
                            "citizen_of_other_country",
                            "Yes"
                          );
                        }}
                        checked={citizenOfOtherCountry === "Yes"}
                      />{" "}
                      Yes{" "}
                      <input
                        type="radio"
                        name="citigenofcountry"
                        onClick={() => {
                          setCitizenOfOtherCountry("No");
                          debounceUpdatePersonalDataField(
                            "citizen_of_other_country",
                            "No"
                          );
                        }}
                        checked={citizenOfOtherCountry === "No"}
                      />{" "}
                      No
                      {/* //YES No Field */}
                      {citizenOfOtherCountry === "Yes" && (
                        <div style={{ fontSize: 12, color: inputError }}>
                          Please contact your brocker
                        </div>
                      )}
                    </p>
                  </div>
                )}
                <div className="col-md-12">
                  <p style={{ color: inputLabelColor }}>
                    <input
                      name="mappingUccDeclaration"
                      type="checkbox"
                      onClick={() => {
                        setMappingUccDeclaration(!mappingUccDeclaration);
                        debounceUpdatePersonalDataField(
                          "mapping_ucc_declaration",
                          !mappingUccDeclaration ? 1 : 2
                        );
                      }}
                      checked={mappingUccDeclaration}
                    />{" "}
                    Declaration for Mapping UCC with Demat Account number*
                  </p>
                  {submitted && !mappingUccDeclaration && (
                    <div style={{ fontSize: 12, color: inputError }}>
                      This option is mandatory.
                    </div>
                  )}
                </div>
                {/* <div className="col-md-12">
              <p style={{ color: inputLabelColor }}>
                <input
                  type="checkbox"
                  onClick={() => {
                    setClientCategoryDeclaration(!clientCategoryDeclaration);
                    debounceUpdatePersonalDataField(
                      "client_category_declaration",
                      !clientCategoryDeclaration ? 1 : 2
                    );
                  }}
                  checked={clientCategoryDeclaration}
                />{" "}
                Client category declaration*
              </p>
              {submitted && !clientCategoryDeclaration && (
                <div style={{ fontSize: 12, color: inputError }}>
                  This option is mandatory.
                </div>
              )}
            </div> */}

                {inputForQuestions && (
                  <>
                    <div className="col-md-12">
                      <Label label="I wish to receive account statement as per SEBI regulation" />
                      <select
                        onChange={(e) => {
                          setWishtoreceiveaccountstatement(e.target.value);
                          debounceUpdatePersonalDataField(
                            "wish_to_receive_account_statement",
                            e.target.value
                          );
                        }}
                        value={wishtoreceiveaccountstatement}
                        className="form-select"
                      >
                        <option value="Daily">Daily</option>
                        <option value="Weekly">Weekly</option>
                        <option value="Fortnightly">Fortnightly</option>
                        <option value="Monthly">Monthly</option>
                      </select>
                    </div>
                    <div className="col-md-12">
                      <Label label="I wish to receive annual report" />
                      <select
                        onChange={(e) => {
                          setWishtoreceiveannualreport(e.target.value);
                          debounceUpdatePersonalDataField(
                            "wish_to_receive_annual_report",
                            e.target.value
                          );
                        }}
                        value={wishtoreceiveannualreport}
                        className="form-select"
                      >
                        <option value="Physically">Physically</option>
                        <option value="Electronically">Electronically</option>
                        <option value="Both">Both</option>
                      </select>
                    </div>
                    <div className="col-md-12">
                      <Label label="I/We would like to share my/our email-id with RTA" />
                      <select
                        onChange={(e) => {
                          setLiketoshareemailwithrta(e.target.value);
                          debounceUpdatePersonalDataField(
                            "like_to_share_email_with_rta",
                            e.target.value
                          );
                        }}
                        value={liketoshareemailwithrta}
                        className="form-select"
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                    <div className="col-md-12">
                      <Label label="Easi : Easi allows a BO to view his ISIN balances, transactions and value of the portfolio online?" />
                      <select
                        onChange={(e) => {
                          setEasiallowsbo(e.target.value);
                          debounceUpdatePersonalDataField(
                            "easi_allows_bo",
                            e.target.value
                          );
                        }}
                        value={easiallowsbo}
                        className="form-select"
                      >
                        <option value="Yes">Yes</option>
                        <option value="No">No</option>
                      </select>
                    </div>
                  </>
                )}
                <div className="col-md-12">
                  <Label
                    label="Non-Issuance of Delivery Slip"
                    className="mt-0"
                  />
                  <select
                    onChange={(e) => {
                      setNonissuanceofdeliveryslip(e.target.value);
                      debounceUpdatePersonalDataField(
                        "non_issuance_of_delivery_slip",
                        e.target.value
                      );
                    }}
                    value={nonissuanceofdeliveryslip}
                    className="form-select"
                  >
                    <option value="I/We do not require the Delivery Instruction Slip (DIS)">
                      I/We do not require the Delivery Instruction Slip (DIS)
                    </option>
                    <option value="I/We require you to issue Delivery Instruction Slip (DIS)">
                      I/We require you to issue Delivery Instruction Slip (DIS)
                    </option>
                  </select>
                </div>
              </div>
            </div>

            {getApiUrl() === VACHANA_API_URL && (
              <div className="col-md-12 mt-3">
                <AccountQA
                  personalInfo={personalInfo}
                  formValue={depositryChargesQuestions}
                  setFormValue={setDepositryChargesQuestions}
                  debounceUpdatePersonalDataField={
                    debounceUpdatePersonalDataField
                  }
                />
              </div>
            )}

            <div className="col-md-12 mt-3">
              <div className="d-flex">
                {showPrevBtnByUrl(
                  history.location.pathname,
                  kycStatus,
                  kycPageName
                ) && (
                  <Button
                    title="Previous"
                    type="button"
                    className="mx-1"
                    handleClick={() => {
                      const route = getPrevAndNextRoute(
                        history.location.pathname.slice(1),
                        kycPageName
                      );
                      history.push(route.prev);
                    }}
                  />
                )}
                <Button
                  name="Submit"
                  title="Submit"
                  type="submit"
                  className="mx-1"
                  disabled={
                    (!allowedPEP && pep == "Yes") ||
                    (!allowedECN && ecn == "Yes") ||
                    (API_URL_NEW == "https://scmcbrke.in/" &&
                      modeOfReceivingEcn == "Physical") ||
                    (API_URL_NEW == "https://scmcbrke.in/" &&
                      bsdaConfirmation == "Yes") ||
                    citizenOfOtherCountry === "Yes" ||
                    isSubmitted ||
                    isUpdating
                  }
                />
                {showNextBtnByUrl(
                  history.location.pathname,
                  kycStatus,
                  kycPageName
                ) && (
                  <Button
                    title="Next"
                    type="button"
                    className="mx-1"
                    handleClick={() => {
                      const route = getPrevAndNextRoute(
                        history.location.pathname.slice(1),
                        kycPageName
                      );
                      history.push(route.next);
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </form>
      </div>
    </React.Fragment>
  );
};

export default PersonalData;
